// extracted by mini-css-extract-plugin
export default {"title":"UseCaseLayout_title__sOm6k","header":"UseCaseLayout_header__d-dxK"};